import React, { useState } from 'react';
import { Info } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@/components/ui/tooltip';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { useIsMobile } from '@/hooks/use-mobile';

/**
 * Info icon that shows a tooltip on hover (desktop) or popover on tap (mobile).
 */
export function InfoHint({ message, className = 'h-8 w-8' }) {
    const isMobile = useIsMobile();
    const [open, setOpen] = useState(false);

    const triggerButton = (
        <Button variant="ghost" size="icon" className={className}>
            <Info className="h-4 w-4" />
        </Button>
    );

    if (isMobile) {
        return (
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>{triggerButton}</PopoverTrigger>
                <PopoverContent
                    side="bottom"
                    align="end"
                    className="w-auto max-w-xs border-0 bg-primary text-primary-foreground text-xs px-3 py-1.5 shadow-md"
                >
                    <p>{message}</p>
                </PopoverContent>
            </Popover>
        );
    }

    return (
        <TooltipProvider delayDuration={200}>
            <Tooltip>
                <TooltipTrigger asChild>{triggerButton}</TooltipTrigger>
                <TooltipContent>
                    <p>{message}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
